import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { LatLng } from "use-places-autocomplete";
import { PagesEnum } from "../../../utils/enums";
import {
  Address,
  DeliveryType,
  FranchiseDeliveryConfig,
} from "../../../utils/types";

export interface InitialState {
  savedAddresses: Address[];
  selectedAddress: Address | null;
  deliveryType: DeliveryType | null;
  currentDeliveryConfig: FranchiseDeliveryConfig | null;
  minEstimatedTime: number;
  maxEstimatedTime: number;
  deliveryFees: number | null;
  deliveryZoneId: number | null;
  backPage: PagesEnum;
  tempLocation: LatLng;
}

const initialState: InitialState = {
  savedAddresses: [],
  deliveryType: null,
  currentDeliveryConfig: null,
  minEstimatedTime: 30,
  maxEstimatedTime: 45,
  deliveryFees: null,
  deliveryZoneId: null,
  backPage: PagesEnum.Home,
  tempLocation: {
    lat: 0,
    lng: 0,
  },
  selectedAddress: null,
};

const config = createSlice({
  name: "delivery",
  initialState,
  reducers: {
    setCurrentDeliveryConfig: (
      state,
      action: PayloadAction<FranchiseDeliveryConfig | null>
    ) => {
      state.currentDeliveryConfig = action.payload;
      if (action.payload) {
        state.deliveryType = action.payload.deliveryType;
        if (!action.payload.usesMap) {
          state.maxEstimatedTime = action.payload.maxEstimatedTime;
          state.minEstimatedTime = action.payload.minEstimatedTime;
          state.deliveryFees = action.payload.deliveryFees;
        }
      } else {
        state.deliveryType = null;
        state.maxEstimatedTime = 45;
        state.minEstimatedTime = 30;
        state.deliveryFees = null;
        state.selectedAddress = null;
      }
    },

    setSavedAddresses: (state, action) => {
      state.savedAddresses = action.payload;
      if (
        state.savedAddresses.findIndex(
          (add) => add.id === state.selectedAddress?.id
        ) === -1
      ) {
        state.selectedAddress = {
          area: "",
          streetName: "",
          buildingNumber: "",
          floorNumber: "",
          apartmentNumber: "",
          addressTitle: "",
          additionalDetails: "",
          lat: 0,
          lng: 0,
          customerId: 0,
        };
      }
    },

    setSelectedAddress: (state, action) => {
      state.selectedAddress = action.payload;
    },
    setTempLocation: (state, action) => {
      state.tempLocation = action.payload;
    },

    setBackPage: (state, action) => {
      state.backPage = action.payload;
    },

    setDeliveryMinMaxFees: (
      state,
      action: PayloadAction<{
        minEstimatedTime: number;
        maxEstimatedTime: number;
        deliveryFees: number | null;
        deliveryZoneId: number;
      }>
    ) => {
      state.minEstimatedTime = action.payload.minEstimatedTime;
      state.maxEstimatedTime = action.payload.maxEstimatedTime;
      state.deliveryFees = action.payload.deliveryFees;
      state.deliveryZoneId = action.payload.deliveryZoneId;
    },
  },
});

export const {
  setSavedAddresses,
  setSelectedAddress,
  setCurrentDeliveryConfig,
  setDeliveryMinMaxFees,
  setTempLocation,
  setBackPage,
} = config.actions;

export default config.reducer;
